export type PostVisibiltyType = 'published' | 'draft' | 'planned';
export type PostVisibiltyTypeUpperCase = Uppercase<PostVisibiltyType>;

export const PostVisibilities: Record<PostVisibiltyTypeUpperCase, PostVisibiltyType> = {
  PUBLISHED: 'published',
  DRAFT: 'draft',
  PLANNED: 'planned',
};

export default PostVisibilities;
